import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import InputField from "components/UI/InputField";
import toast from "react-hot-toast";
import { PositionSchema } from "validation/schema/position.schema";
import FileUpload from "components/UI/FileUpload";
import { axiosUnos } from "common/api/axios/unos_axios";
import { FILE_UP_NAME } from "common/constants";

type PositionUploadProps = {
  fileUploadHandle: Function;
  fileNameDefault?: string;
};

const PositionUpload = ({
  fileUploadHandle,
  fileNameDefault,
}: PositionUploadProps) => {
  //   const onSubmit = async (data: any) => {
  //     console.log(data);

  //     toast.success("New position added");
  //   };
  //   const fileUploadHandle = (upRes: any) => {
  //     console.log("fileUploadHandle", upRes);
  //   };
  const uploadUrl = "position/up";

  return (
    <DivUpload>
      <FileUpload
        axiosInstance={axiosUnos}
        fileFieldName={FILE_UP_NAME}
        fileUploadHandle={fileUploadHandle}
        uploadUrl={uploadUrl}
        showUploadedFile
        fileNameDefault={fileNameDefault}
      />
    </DivUpload>
  );
};

const DivUpload = styled.div`
  display: flex;
`;

export default PositionUpload;
